// extracted by mini-css-extract-plugin
export default {"opening":"_3qedYe0Wditj6NcDzCepNq","opening--active":"_2H9KT9-eCyEuK6JRY_AnVk"};